var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"uppercase text-xs font-main-bold py-4"},[_vm._v(" Récapitulatif de la session ")])}
var staticRenderFns = []

export { render, staticRenderFns }